// Typelizer digest 0a5e2c385cc3f953dbfaaba3ef09eea7
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /rails/active_storage/blobs/redirect/:signed_id/*filename */
  show: (
    params: { signedId: string | number; filename: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/rails/active_storage/blobs/redirect/:signed_id/*filename', params, options),
    method: 'get',
  }),
}
